<footer class="footer" id="footer">
    <div class="footer__top">
        <div class="grid-container">
            <div class="grid-x ">
                <div class="cell small-12 medium-6">
                    <ng-content select="[main]"></ng-content>
                </div>
                <div class="cell small-12 medium-6">
                    <ng-content select="[switcher]"></ng-content>
                </div>
            </div>
        </div>
    </div>
    <div class="grid-container">
        <div class="grid-x">
            <div class="cell small-12 medium-7">
                <ul class="no-bullet flex-container">
                    <ng-content select="[linkList]"></ng-content>
                </ul>
            </div>
            <div class="cell small-12 medium-5 text-center medium-text-right footer__copyright" data-test="mono-common-footer-copyright">
                &copy; {{dateObject | date :'yyyy'}} <a href="https://goodthingsfoundation.org" target="_blank">Good Things Foundation</a>
            </div>
        </div>
    </div>
</footer>
